import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '../../lib/cn.js';

type Props = SelectHTMLAttributes<HTMLSelectElement> & {
  invalid?: boolean;
};

export const Select = forwardRef<HTMLSelectElement, Props>(function Select(
  { invalid, className, children, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      className={cn(
        'h-11 w-full rounded-lg border px-3 text-[15px] leading-none appearance-none',
        'bg-white text-ink',
        'border-line hover:border-line-strong',
        'transition-colors duration-150',
        'focus-visible:outline-none focus-visible:border-navy focus-visible:ring-2 focus-visible:ring-navy/20',
        invalid && 'border-danger focus-visible:border-danger focus-visible:ring-danger/20',
        'disabled:bg-cream-deep/40 disabled:cursor-not-allowed',
        // Chevron via inline SVG background
        "bg-[url('data:image/svg+xml;utf8,<svg%20xmlns=\"http://www.w3.org/2000/svg\"%20viewBox=\"0%200%2020%2020\"%20fill=\"%237A6E5E\"><path%20d=\"M5.3%207.3a1%201%200%20011.4%200L10%2010.6l3.3-3.3a1%201%200%20111.4%201.4l-4%204a1%201%200%2001-1.4%200l-4-4a1%201%200%20010-1.4z\"/></svg>')] bg-no-repeat bg-[right_0.75rem_center] pr-9",
        className,
      )}
      {...rest}
    >
      {children}
    </select>
  );
});
